export default {
    state: {
        restrictions: []
    },
    mutations: {
        setValueRestrictions (state, data) {
            state.restrictions = data
        }
    },
    actions: {
        setValueRestrictions ({ commit }, data) {
            commit('setValueRestrictions', data)
        }
    },
    getters: {
        getValueRestrictions: (state) => state.restrictions
    }
}
